export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Header.vue?vue&type=style&index=0&id=ba3abd38&prod&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/header/Header.vue?vue&type=style&index=0&id=ba3abd38&prod&lang=css&
// module id = 892
// module chunks = 0